import React from 'react';
import { Checkbox } from 'react-bootstrap';
import moment from 'moment';
import { DAY_KANA, EMPTY_COUNT, EMPTY_STRING, NO_RECORDS_FOUND, SHORT_TRUE, FIRST_INDEX } from '../../../utils/constants';
import { isNullOrUndefined } from '../../../../node_modules/util';

const OrderMonthlyTable = (props) => {
    const smallHeaderStyle = "custom-order-header order-row-small";
    const fullHeaderStyle = "custom-order-header full-width";
    const smallRowStyle = "custom-order-row order-row-small";
    const fullRowStyle = "custom-order-row full-width flex-align-center pl-20";
    const fullFlex = "flex full-width";

    const inputClassName = (row) => {
        let className = EMPTY_STRING;

        if (row.hasOrder) {
            className += "text-red ";
        }

        if (row.isDisabled) {
            className += "mobile-number-input-disabled";
            if(row.hasOrder){
                if (!row.isPlainBG){
                    className += "-bg-yellow ";
                } else {
                    className += "-bg-plain ";
                } 
            } else {
                className += "-bg-plain ";
            }
        } else {
            className += "mobile-number-input ";
            if(row.hasOrder){
                if (!row.isPlainBG){
                    className += "bg-yellow ";
                }
            }
        }

        return className;
    }

    const RenderRows = (
        props.dayChecklist.map((row, index) => {

            let isDefaultValue = isNullOrUndefined(row.orderedProducts);
           
            return (
                <div key={index} className={[fullFlex, " bottom-border-gray"]}>
                    <div>
                        <Checkbox
                            className="mobile-checkbox"
                            onChange={row.isDisabled ? null : props.handleCheckboxChange}
                            id={`check-${index}`}
                            checked={row.isChecked}
                            disabled={row.isDisabled}
                        />
                    </div>
                    <div className={[fullRowStyle]} id={`check-${index}`} onClick={row.isDisabled ? null : props.handleCheckboxChange}>
                        {`${moment(row.deliveryDate).format("MM/DD")} (${DAY_KANA[moment(row.deliveryDate).day()]})`}
                    </div>
                    <div className={smallRowStyle}>
                        <input
                            id={index.toString()}
                            type="number"
                            className={inputClassName(row)}
                            onFocus={()=>{
                                if(isDefaultValue || EMPTY_COUNT === row.orderedProducts){
                                    document.getElementById(`${index.toString()}`).value = undefined;
                                }else{
                                    document.getElementById(`${index.toString()}`).value = row.orderedProducts;
                                }
                            }}
                            onBlur={()=>{
                                if(isDefaultValue){
                                    document.getElementById(`${index.toString()}`).value = undefined;
                                }else{
                                    document.getElementById(`${index.toString()}`).value = row.orderedProducts;
                                }
                            }}
                            value={isDefaultValue ? EMPTY_STRING :  row.orderedProducts}
                            onChange={props.handleInputChange}
                            disabled={row.isDisabled}
                            pattern="\d+"
                        />
                    </div>
                    {SHORT_TRUE === row.displayForecast ? <div className={smallRowStyle}>{props.predictions[moment(row.deliveryDate).format("DD") - 1]}</div> : "" }
                </div>
            )

        })
    )

    return (
        <div>
            <div className={fullFlex}>
                <div className={fullHeaderStyle}></div>
                <div className={smallHeaderStyle}>発注数</div>
                {props.dayChecklist[FIRST_INDEX] && (SHORT_TRUE === props.dayChecklist[FIRST_INDEX].displayForecast) ? <div className={smallHeaderStyle}>(予測数)</div>: ""}
            </div>
            {EMPTY_COUNT < props.dayChecklist.length ? RenderRows : NO_RECORDS_FOUND}
        </div>
    )
}

export default OrderMonthlyTable;